import { useAuthStore } from '@/stores/auth-store';

export function usePermission(permission: string): boolean {
  const { user } = useAuthStore();

  if (!user) return false;

  // Admins or superusers generally have all permissions, but explicit check is safer
  if (user.is_superuser) return true;

  return user.all_permissions?.includes(permission) ?? false;
}
